import moment from "moment";
import i18n from '@/i18n';
export function display_date(value, strFormat) {
  // Giả định value là GMT, chuyển sang GMT+7 khi hiển thị
  return value ? moment.utc(value).utcOffset(7 * 60).format(strFormat ? strFormat : 'DD-MM-YYYY HH:mm:ss') : '';
}

import config from '../configs'

export function vip_level(value){
  const objRet = config.VIP_LEVEL.find(obj => obj.value === value);
  return objRet ? objRet.name : '';
}

export function vip_level_color(value){
  const objRet = config.VIP_LEVEL.find(obj => obj.value === value);
  return objRet ? objRet.color : '';
}

export function capitalize(value){
  return value.toLowerCase().replace(/^.|\s\S/g, function(a) { return a.toUpperCase(); });
};

export function display_value(value, enums, key_field = 'value', value_field = 'name') {
  const item = enums.find(obj => obj[key_field] === value);
  return item ? item.i18n ? i18n.t(item.i18n) : item[value_field] : '';
}

export function display_color(value, enums) {
  const item = enums.find(obj => obj.value === value);
  return item ? item.color : '';
}

export function display_text_color(value, enums) {
  const item = enums.find(obj => obj.value === value);
  return item ? item.textColor : '';
}